export default __webpack_public_path__ + "static/media/Loader.1000be2f.gif";